import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Component, createRef, render } from "preact";
import { getLiveInfo, livePayment } from "../api/Client";
import { currencyFormat } from "../util/Formatter";
import { SessionStorage } from "../util/SessionStorage";
import { PaymentMethodComponent } from "./PaymentMethodComponent";
import { IframeThreeDsAuthorizationWindow } from "./threeds-authorization/IframeThreeDsAuthorizationWindow";
const WEBSOCKET_ENDPOINT = process.env.WEBSOCKET_ENDPOINT;
class TipPaymentComponent extends Component {
    constructor() {
        super();
        this.state = {
            live: null,
            livePayments: [],
            selectedLivePayment: null,
            message: "",
            nickName: "",
        };
        this.paymentMethodComponentRef = createRef();
        // 決済ボタンのイベントバインド
        const settlementBtn = document.querySelector('.TipPaymentComponent__SubmitHook');
        settlementBtn?.addEventListener('click', e => {
            e.preventDefault();
            this.toggleExecuteButton();
            this.paymentMethodComponentRef.current?.submitHook();
        });
        this.finishUrl = settlementBtn?.getAttribute('href');
        document.addEventListener('--get-token-finish', () => {
            this.executePayment();
        });
        document.addEventListener('--get-token-invalidate', () => {
            this.toggleExecuteButton();
        });
        this.handleAuthorizationComplete = this.handleAuthorizationComplete.bind(this);
    }
    render() {
        return (_jsxs("article", { children: [_jsxs("h4", Object.assign({ class: "content__title" }, { children: [_jsx("span", { class: "heading" }, void 0), this.state.live?.tipGroupName] }), void 0),
                _jsxs("div", Object.assign({ class: "form-container mb2" }, { children: [_jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ className: "label" }, { children: "\u30E9\u30A4\u30D6ID" }), void 0),
                                _jsx("p", { children: this.state.live?.liveId }, void 0)] }), void 0),
                        _jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ className: "label" }, { children: "\u8CFC\u5165\u30E1\u30C3\u30BB\u30FC\u30B8\u67A0\u3092\u9078\u629E\uFF08\u5FC5\u9808\uFF09" }), void 0),
                                _jsx("div", Object.assign({ class: "select control w100" }, { children: _jsx("select", Object.assign({ class: "w100", onInput: (e) => this.setLivePayment(e) }, { children: this.state.livePayments.map(livePayment => _jsxs("option", Object.assign({ value: livePayment.id }, { children: [currencyFormat(livePayment.payamount), "\uFF08\u5168\u89D2", livePayment.messageLimitSize, "\u6587\u5B57\uFF09"] }), void 0)) }), void 0) }), void 0)] }), void 0),
                        _jsxs("div", Object.assign({ class: "field" }, { children: [_jsx("label", Object.assign({ className: "label" }, { children: "\u30CB\u30C3\u30AF\u30CD\u30FC\u30E0" }), void 0),
                                _jsx("input", { type: "text", class: "input", maxLength: 256, onInput: e => this.handleNickNameInput(e) }, void 0)] }), void 0),
                        _jsxs("div", Object.assign({ class: "field" }, { children: [_jsxs("label", Object.assign({ className: "label" }, { children: ["\u30E1\u30C3\u30BB\u30FC\u30B8\uFF08\u5168\u89D2", this.state.selectedLivePayment?.messageLimitSize, "\u6587\u5B57\u307E\u3067\u5165\u529B\u53EF\u80FD)"] }), void 0),
                                _jsx("textarea", { class: "textarea", maxLength: this.state.selectedLivePayment?.messageLimitSize, disabled: this.state.selectedLivePayment?.messageLimitSize === 0, onInput: e => this.handleMessageInput(e) }, void 0),
                                _jsxs("p", Object.assign({ class: "help" }, { children: ["\u73FE\u5728", this.state.message.length, "\u6587\u5B57"] }), void 0)] }), void 0)] }), void 0),
                _jsxs("h4", Object.assign({ class: "content__title" }, { children: [_jsx("span", { class: "heading" }, void 0), "\u304A\u652F\u6255\u3044\u60C5\u5831"] }), void 0),
                _jsx(PaymentMethodComponent, { storeId: this.props.storeId, storeType: this.props.storeType, cartType: "LIVE", ref: this.paymentMethodComponentRef }, void 0),
                _jsx(IframeThreeDsAuthorizationWindow, { orderCode: this.state.orderCode, authorizationUrl: this.state.acsUrl, onComplete: this.handleAuthorizationComplete }, void 0)] }, void 0));
    }
    componentDidMount() {
        const { storeId, systemUserId, liveId } = this.props;
        getLiveInfo(storeId, systemUserId, liveId).then(response => {
            this.setState({
                live: response.data,
                livePayments: response.data.livePayments,
                selectedLivePayment: response.data.livePayments[0],
            });
        }).catch(e => {
            alert('ライブ情報の取得に失敗しました');
            throw e;
        });
    }
    setLivePayment(e) {
        const target = e.target;
        const livePaymentId = Number(target.value);
        const selected = this.state.livePayments.filter(p => p.id === livePaymentId)[0];
        this.setState({ selectedLivePayment: selected });
    }
    handleMessageInput(event) {
        const textarea = event.target;
        this.setState({ message: textarea.value });
    }
    handleNickNameInput(event) {
        const input = event.target;
        this.setState({ nickName: input.value });
    }
    executePayment() {
        const { storeId, systemUserId, liveId } = this.props;
        const liveForm = {
            liveId: liveId,
            livePaymentId: this.state.selectedLivePayment.id,
            storeId: storeId,
            systemUserId: systemUserId,
            message: this.state.message,
            userName: this.state.nickName,
        };
        const paymentForm = this.paymentMethodComponentRef.current.getPaymentFormObject();
        livePayment(liveForm, paymentForm).then(response => {
            const { storeName } = this.props;
            const { payamount } = this.state.selectedLivePayment;
            const { tipGroupName, liveId } = this.state.live;
            const { orderCode, acsUrl, encryptedOrderCode, message } = response.data;
            const { paymentMethod, cardNo, paytime, cardBrand } = paymentForm;
            // 決済完了画面で使うパラメータを設定
            SessionStorage.TipPayment.setPaymentInfo({
                storeName: storeName,
                groupName: tipGroupName,
                liveId: liveId,
                payAmount: payamount,
                nickName: this.state.nickName,
                message: this.state.message,
                orderCode: orderCode,
                encryptedOrderCode: encryptedOrderCode,
                cardBrand: cardBrand,
                maskedCardNo: cardNo,
                paymentMethod: paymentMethod,
                paytime: paytime
            });
            if (typeof acsUrl === 'string') {
                this.setState({
                    orderCode,
                    acsUrl
                });
                this.messageObject = message;
                // 3DS認証が必要な場合は待機
                return;
            }
            const socket = new WebSocket(`${WEBSOCKET_ENDPOINT}?group=${liveId}&identifier=${orderCode}`);
            message.createdAt = message.updatedAt;
            socket.onopen = () => {
                socket.send(JSON.stringify({ action: "sendmessage", data: { message: message, group: liveId } }));
                if (this.finishUrl) {
                    location.href = this.finishUrl;
                }
            };
        }).catch(e => {
            alert(e.response.data.error);
            throw e;
        }).finally(() => {
            this.toggleExecuteButton();
        });
    }
    handleAuthorizationComplete(errorMessages) {
        if (errorMessages.length > 0) {
            alert(errorMessages[0]);
            return;
        }
        const { orderCode = '' } = this.state;
        const { liveId } = this.state.live;
        const socket = new WebSocket(`${WEBSOCKET_ENDPOINT}?group=${liveId}&identifier=${orderCode}`);
        this.messageObject.createdAt = this.messageObject.updatedAt;
        socket.onopen = () => {
            socket.send(JSON.stringify({ action: "sendmessage", data: { message: this.messageObject, group: liveId } }));
            if (this.finishUrl) {
                location.href = this.finishUrl;
            }
        };
    }
    toggleExecuteButton() {
        const target = document.querySelector('.TipPaymentComponent__SubmitHook');
        if (target) {
            target.disabled = !target.disabled;
            target.innerHTML = target.disabled ? "決済中..." : '決済する';
        }
    }
}
document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('#TipPaymentComponent');
    if (root) {
        const storeId = Number(root.getAttribute('data-store-id'));
        const storeType = root.getAttribute('data-store-type');
        const storeName = root.getAttribute('data-store-name');
        const systemUserId = root.getAttribute('data-systemuser-id');
        const liveId = root.getAttribute('data-live-id');
        render(_jsx(TipPaymentComponent, { storeId: storeId, storeName: storeName, storeType: storeType, systemUserId: systemUserId, liveId: liveId }, void 0), root);
    }
});
